import moment from 'moment-jalaali';

// gets total passengers in each room
export const roomsInfo = (rooms) => {
    let adultCount = 0;
    let childCount = 0;
    for (const room of rooms) {
        adultCount += room.adults.length;
        childCount += room.children.length;
    }
    return {
        adultCount,
        childCount,
        roomCount: rooms.length,
    };
};

// Used in available page. If can
export const disableFiltersOfAvailable = (result, isSearchLoading, mapIsOpen) => {
    // If no results returned so filters must work
    if ((!isSearchLoading && result.length === 0) || mapIsOpen) {
        return false;
    }
    return !result.find((item) => item.usable);
};

export const isDomesticHotel = (countryCode) => {
    return countryCode.toLowerCase() === 'ir';
};

export const domesticHotelName = (value) => {
    if (value && !value.includes('هتل')) {
        return 'هتل ' + value;
    }
    return value;
};

const packageText = ({ start, end }) => {
    const fromText = moment(start).format('jD jMMMM jYY');
    const toText = moment(end).format('jD jMMMM jYY');
    return `این هتل از ${fromText} تا ${toText} بصورت پکیج است`;
};

const minNightText = ({ start, end, minNight }) => {
    const fromText = moment(start).format('jD jMMMM jYY');
    const toText = moment(end).format('jD jMMMM jYY');
    return minNight ? `این هتل از تاریخ ${fromText} تا ${toText} فقط با مدت زمان ${minNight} شب قابل رزرو است.` : '';
};

export const offerText = (offer) => {
    if (offer.packages.length) {
        return packageText({ start: offer.packageRange.start, end: offer.packageRange.end });
    } else if (offer.minNightRules.length) {
        return minNightText({
            start: offer.minNightRange.start,
            end: offer.minNightRange.end,
            minNight: offer.minNightRules[0].value.minNight,
        });
    }
    return '';
};
